import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}
  transform(value?: string) {
    if (!value) {
      return '';
    }
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
